export default {
  type: 'editor.elements.ShapeElement',
  name: 'Rectangle',
  icon: 'M19,6H22V8H19V11H17V8H14V6H17V3H19V6M17,17V14H19V19H3V6H11V8H5V17H17Z',
  order: 90,
  tooltip: 'Design element to use as backgrounds, lines etc.',
};
